export const markAsUnread = "sRa";
export const markAsUnreadNumberOfConversationsWhenCountIsNegative = "tRa";
export const markAsUnreadNumberOfItemsWhenCountIsNegative = "uRa";
export const markAsUnreadNumberOfConversations = "vRa";
export const markAsUnreadNumberOfItems = "wRa";
export default {markAsUnread,markAsUnreadNumberOfConversationsWhenCountIsNegative,markAsUnreadNumberOfItemsWhenCountIsNegative,markAsUnreadNumberOfConversations,markAsUnreadNumberOfItems};